module.exports = __webpack_public_path__ + "static/img/photo-01.27feb82.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/slides_photo/photo-01.jpg
// module id = 54De
// module chunks = 0